import { BREACHED_PROPERTY_VALUE, SLA_WARNING_PROPERTY_VALUE } from 'conversations-internal-schema/sla/constants/enums';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const SLADueDatePreview = ({
  slaStatus
}) => {
  switch (slaStatus) {
    case BREACHED_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.breached"
      });
    case SLA_WARNING_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.warning"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.inSLA"
      });
  }
};
SLADueDatePreview.displayName = 'SLADueDatePreview';